/**
 * dp Video Content runtime helper
 *
 * Reads the JSON payload emitted by the dp-video-content block and logs
 * basic validation info to the console. No player implementation yet.
 */

function safeParseJson(text) {
  try {
    return JSON.parse(text);
  } catch (e) {
    return null;
  }
}

function validatePayload(payload) {
  const errors = [];
  if (!payload || typeof payload !== "object") {
    errors.push("Missing or invalid payload");
    return errors;
  }
  if (!payload.videoId || String(payload.videoId).trim() === "") {
    errors.push("videoId is required");
  }
  return errors;
}

function initDpVideoContent() {
  const roots = document.querySelectorAll(".dp-video-content");
  if (!roots.length) return;

  roots.forEach((root) => {
    const payloadEl = root.querySelector(
      'script.dp-video-content__payload[type="application/json"]'
    );
    const payload = payloadEl
      ? safeParseJson(payloadEl.textContent || "")
      : null;
    const errors = validatePayload(payload);

    if (errors.length) {
      // eslint-disable-next-line no-console
      console.warn("[dp-video-content] Invalid payload", {
        errors,
        payload,
        el: root,
      });
      return;
    }

    // eslint-disable-next-line no-console
    console.info("[dp-video-content] Payload OK", payload);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDpVideoContent);
} else {
  initDpVideoContent();
}
